import { BreadCrumb } from '@lib/components/BreadCrumbs/types';
import { BreadCrumbsOptions } from './types';
import getHomeBreadcrumbMap from './home';
import getUsersBreadcrumbMap from './users';
import getTeamsBreadcrumbMap from './teams';
import getDepartmentsBreadcrumbMap from './departments';
import getSitesBreadcrumbMap from './sites';
import getSectorsBreadcrumbMap from './sectors';
import getFormTemplatesBreadcrumbMap from './formTemplates';
import getAssetsBreadcrumbMap from './assets';
import getInterventionsBreadcrumbMap from './interventions';
import getTasksBreadcrumbMap from './tasks';
import getSsoBreadcrumbMap from './sso';
import getDocumentationBreadcrumbMap from './documentation';
import getFormChecklistsBreadcrumbMap from './formChecklists';

export function getBreadCrumbsDataByKey(options: BreadCrumbsOptions) {
  const breadcrumbMap = [
    ...getHomeBreadcrumbMap(options),
    ...getUsersBreadcrumbMap(options),
    ...getTeamsBreadcrumbMap(options),
    ...getDepartmentsBreadcrumbMap(options),
    ...getSitesBreadcrumbMap(options),
    ...getSectorsBreadcrumbMap(options),
    ...getFormTemplatesBreadcrumbMap(options),
    ...getAssetsBreadcrumbMap(options),
    ...getInterventionsBreadcrumbMap(options),
    ...getTasksBreadcrumbMap(options),
    ...getSsoBreadcrumbMap(options),
    ...getDocumentationBreadcrumbMap(options),
    ...getFormChecklistsBreadcrumbMap(options),
  ];

  const matchedCrumb = breadcrumbMap.find((crumb) => crumb.condition);
  return (matchedCrumb ? matchedCrumb.data : []) as BreadCrumb[];
}
